class IncidentController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        $scope.showCreateDiv = true
        let userId;
        let selectedUsers = localStorageService.get('selectedUsers')
        if (selectedUsers && selectedUsers.length === 1)
            userId = selectedUsers[0].user_id
        $scope.gotoFirstAid = () => {
            $state.go("firstAidForm")
        }
        $scope.gotoRedirectForm = () => {
            $state.go("referralForm")
        }
        $scope.gotoVaccinationForm = () => {
            $state.go("vaccinationForm")
            /*if (selectedUsers) {
                if (selectedUsers.length === 1) {
                    $scope.getDiagnosticReply = Doctor_Immunization.findOne({
                        "type": "reply",
                        "user_id": userId,
                        "doctor_id": Meteor.userId()
                    })
                    if ($scope.getDiagnosticReply && $scope.getDiagnosticReply.status == "replied") {
                        $state.go("vaccinationForm")
                    } else
                        toastr.error("This user doesn't replied for immunization questions")
                } else {
                    let userCount = selectedUsers.length
                    $scope.selectedUsersForVaccination = []
                    _.each(selectedUsers, function(eachUser) {
                        $scope.getDiagnosticReply = Doctor_Immunization.findOne({
                            "type": "reply",
                            "user_id": eachUser.user_id,
                            "doctor_id": Meteor.userId()
                        })
                        if ($scope.getDiagnosticReply && $scope.getDiagnosticReply.status == "replied")
                            $scope.selectedUsersForVaccination.push(eachUser)

                    })
                    if ($scope.selectedUsersForVaccination && $scope.selectedUsersForVaccination.length > 0) {
                        $state.go("vaccinationForm")
                    } else
                        toastr.error("None of the users replied for Immunization questions")
                }
            }*/
        }
    }
}

export default IncidentController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/incidents/incidents.js